export default __webpack_public_path__ + "static/media/logo-.992ef5f8.png";